<template>
    <div class="Final Requisition">
        <Navbar></Navbar>
        <b-modal 
            v-model="showModal" 
            :title="modalTitle"
            :header-bg-variant="modalVariant"
            header-text-variant="light"
            centered
            no-close-on-backdrop
            hide-header-close 
            @hidden="handleModalClose"
        >
            <p class="my-2 text-center" style="font-size: 1.1rem;">{{ modalMessage }}</p>
            
            <div v-if="showClipboard" class="mt-4">
                <div class="bg-light p-3 rounded border position-relative">
                    <pre class="mb-0" style="font-size: 0.9rem; font-family: monospace; white-space: pre-wrap; color: #333;">{{ clipboardText }}</pre>
                </div>
            </div>

            <template #modal-footer>
                <div class="w-100 text-center">
                    <button v-if="showClipboard" @click="copyToClipboard" class="btn btn-primary font-weight-bold shadow-sm px-4">
                        <i class="fas" :class="copyButtonIcon"></i> {{ copyButtonText }}
                    </button>
                    <button v-else @click="handleModalClose" class="btn btn-secondary font-weight-bold shadow-sm px-4">
                        OK
                    </button>
                </div>
            </template>
        </b-modal>

        <div class="container pt-3 pb-5">

            <div class="row mb-4">
                <div class="col-12">
                  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center border-bottom pb-3">
                    <div class="mb-3 mb-md-0">
                      <h2 class="font-weight-bold text-dark mb-1">
                        <i class="fas fa-exclamation-triangle text-danger mr-2"></i> Mismatch
                      </h2>
                      <p class="text-muted mb-0">Report Product Count Mismatch </p>
                    </div>
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb bg-white shadow-sm rounded mb-0 px-3 py-2 border">
                        <li class="breadcrumb-item">
                          <a href="#" @click.prevent="$router.push('/')" class="text-muted">
                            <i class="fas fa-home"></i> Home
                          </a>
                        </li>
                        <li class="breadcrumb-item">
                          <a href="#" @click.prevent="$router.push('/devices')" class="text-muted">Devices</a>
                        </li>
                        <li class="breadcrumb-item active font-weight-bold text-danger" aria-current="page">
                          Mismatch
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            
            <div class="header-banner bg-white shadow-sm rounded p-3 p-md-4 mt-3 mb-4 d-flex flex-column flex-sm-row justify-content-between align-items-center" v-if="magazines.length">
                <div class="text-center text-sm-left mb-3 mb-sm-0">
                    <span class="text-muted text-uppercase small font-weight-bold tracking-wide">
                        <i class="fas fa-server mr-1"></i> Current Device
                    </span>
                    <h2 class="mb-0 font-weight-bold text-dark mt-1">
                        {{ DeviceSelected.name }}
                    </h2>
                </div>
                <div>
                    <button @click="goToRefillPage" class="btn btn-outline-secondary font-weight-bold shadow-sm px-4 btn-back">
                        <i class="fas fa-arrow-left mr-2"></i> রিফিল এ ফিরে যান
                    </button>
                </div>
            </div>
            
            <div v-if="magazines.length">
                <h3 class="mb-4" style="color: #dc3545; text-align: center; font-weight: 700; font-size: 1.5rem;">
                    <i class="fas fa-clipboard-list mr-2"></i> ডিভাইসে যে সকল প্রোডাক্ট আছে তার একটা লিস্ট নিচে দেওয়া হলো
                </h3>
            </div>

            <div class="d-block d-md-none" v-if="magazines.length">
                <div class="row">
                    <div class="col-12 mb-3" v-for="(item1, index) in magazines" :key="'mob-' + index">
                        <div class="card shadow-sm border-0 custom-mobile-card">
                            <div class="card-body p-3">
                                
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="badge badge-pill badge-light border text-uppercase px-2 py-1">
                                        <i class="fas fa-ruler-horizontal mr-1"></i> Mag {{ item1.magazine_number }}
                                    </span>
                                    <span class="badge badge-pill badge-info border px-2 py-1">
                                        <i class="fas fa-box mr-1"></i>{{ item1.pack_system }}
                                    </span>
                                    
                                </div>
                                <h6 class="mb-3 font-weight-bold text-center">{{ item1.product_type }}</h6>
                                
                                <div class="row text-center mb-3 mx-0 stats-box rounded bg-light border p-2">
                                    <div class="col-6 border-right px-1">
                                        <small class="text-muted d-block text-uppercase font-weight-bold">ক্যাপাসিটি</small>
                                        <span class="font-weight-bold" style="font-size: 1.1rem;">{{ item1.max_capacity }}</span>
                                    </div>
                                    <div class="col-6 px-1">
                                        <small class="text-muted d-block text-uppercase font-weight-bold">সার্ভারে আছে
                                        </small>
                                        <span class="font-weight-bold text-info" style="font-size: 1.1rem;">{{ item1.count }}</span>
                                    </div>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="small text-muted font-weight-bold mb-1">ডিভাইসে আছে</label>
                                    <b-form-input 
                                        v-model="selectedRequestProduct[index]" 
                                        type="text"
                                        class="text-center border-secondary shadow-sm"
                                        placeholder="কাউন্ট">
                                    </b-form-input>
                                </div>

                                <button @click="OnClickRefillProduct(item1, index)" 
                                :disabled="loadingIndex === index"
                                class="btn btn-danger btn-block font-weight-bold shadow-sm">
                                    <i class="fas fa-sync-alt mr-1" :class="{ 'fa-spin': loadingIndex === index }"></i> 
                                    {{ loadingIndex === index ? 'আপডেট হচ্ছে...' : 'আপডেট' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive mt-3 d-none d-md-block shadow-sm rounded" v-if="magazines.length">
                <table class="table table-bordered table-hover text-center cart-table bg-white mb-0">
                    <thead class="thead-dark">
                        <tr class="table-head">
                            <th class="align-middle">Magazine Number</th>
                            <th scope="col" class="align-middle">Product</th>
                            <th scope="col" class="align-middle">Maximum Capacity</th>
                            <th scope="col" class="align-middle">Available On Server </th>
                            <th scope="col" class="align-middle" style="min-width: 150px;">Available on Device</th>
                            <th scope="col" class="align-middle">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item1, index) in magazines" :key="'desk-' + index">
                            <td class="align-middle">
                                <h6 class="mb-0"> {{ item1.magazine_number }}</h6>
                            </td>
                            <td class="align-middle">
                                <h6 class="mb-0 text-primary font-weight-bold"> {{ item1.product_type }}</h6>
                            </td>
                            <td class="align-middle">
                                <h6 class="mb-0"> {{ item1.max_capacity }}</h6>
                            </td>
                            <td class="align-middle">
                                <h6 class="mb-0 text-info font-weight-bold"> {{ item1.count }}</h6>
                            </td>
                            <td class="align-middle">
                                <b-form class="m-0">
                                    <b-form-group class="mb-0">
                                        <b-form-input 
                                            v-model="selectedRequestProduct[index]" 
                                            type="text"
                                            class="text-center"
                                            placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </b-form>
                            </td>
                            <td class="align-middle">
                                <button @click="OnClickRefillProduct(item1, index)" 
                                :disabled="loadingIndex === index"
                                class="btn btn-danger btn-sm w-100 font-weight-bold">
                                    <i class="fas fa-sync-alt mr-1" v-if="loadingIndex === index" :class="{ 'fa-spin': loadingIndex === index }"></i>
                                    {{ loadingIndex === index ? 'Updating...' : 'Update' }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import { getAPI } from './axios-api.js';
import { BFormInput, BFormGroup, BForm, BModal } from 'bootstrap-vue'
import moment from 'moment'

export default {
    name: 'Requsition',
    components: {
        Navbar,
        'b-form-input': BFormInput,
        'b-form-group': BFormGroup,
        'b-form': BForm,
        'b-modal': BModal
    },

    created() {
        this.loadData()
        console.log("here")
    },
    data() {
        return {
            DeviceSelected: '',
            DeviceSelectedName: '',
            magazines: '',
            selectedRequestProduct: [],
            agent_products: '',
            tmode: 'False',
            status: '',
            loadingIndex: null,
            showModal: false,
            modalTitle: '',
            modalMessage: '',
            modalVariant: 'info',
            shouldReloadOnClose: false,
            // New Clipboard Variables
            showClipboard: false,
            clipboardText: '',
            copyButtonText: 'Copy Text',
            copyButtonIcon: 'fa-copy'
        }
    },
    methods: {
        parseDateString(date) {
            return moment(String(date)).format('DD.MM.YYYY')
        },
        // Modal Helper Method
        showNotification(title, message, variant = 'primary', shouldReload = false, clipboardData = null) {
            this.modalTitle = title;
            this.modalMessage = message;
            this.modalVariant = variant;
            this.shouldReloadOnClose = shouldReload;
            
            if (clipboardData) {
                this.clipboardText = clipboardData;
                this.showClipboard = true;
                this.copyButtonText = 'Copy Text';
                this.copyButtonIcon = 'fa-copy';
            } else {
                this.showClipboard = false;
                this.clipboardText = '';
            }

            this.showModal = true;
        },

        async copyToClipboard() {
            try {
                // 1. Try modern clipboard API (HTTPS)
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(this.clipboardText);
                } 
                // 2. Fallback for mobile/HTTP testing
                else {
                    const textArea = document.createElement("textarea");
                    textArea.value = this.clipboardText;
                    textArea.style.position = "fixed";
                    textArea.style.left = "-999999px";
                    textArea.style.top = "-999999px";
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    const successful = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    if (!successful) throw new Error('Fallback copy failed');
                }

                // Visual Feedback
                this.copyButtonText = 'Copied!';
                this.copyButtonIcon = 'fa-check text-white';
                
                // Wait 800ms so the user sees "Copied!", then auto-close & refresh
                setTimeout(() => {
                    this.handleModalClose();
                }, 800);

            } catch (err) {
                console.error('Failed to copy text: ', err);
                alert("Failed to copy. Please manually select and copy the text.");
            }
        },

        // Modal Close Handler
        handleModalClose() {
          this.showModal = false;
          if (this.shouldReloadOnClose) {
                this.shouldReloadOnClose = false; 
                setTimeout(() => {
                    this.$router.go();
                }, 500);
            }
        },
        async loadData() {
            var disdata = {}

            this.DeviceSelectedName = localStorage.getItem('DeviceSelected')
            console.log(this.DeviceSelectedName)
            const payload = {
                name: this.DeviceSelectedName
            }
            getAPI.post('/singleProduct/', payload, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`
                }
            })
                .then(response => {
                    disdata = response['data']['SRU'];
                    console.log(disdata);
                    this.DeviceSelected = disdata;
                })

            getAPI.post('/getMagazines/', payload, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`
                }
            })
                .then(response => {
                    disdata = response['data'];
                    console.log(disdata);
                    this.magazines = disdata['magazines']
                })

            getAPI.post('/agentProducts/', payload, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`
                }
            })
                .then(response => {
                    disdata = response['data'];
                    console.log(disdata);
                    this.agent_products = disdata['agent_product']
                })

            console.log(this.$store.state.tryselectedDevice)
        },


        async OnClickRefillProduct(item, index) {
            console.log(this.selectedRequestProduct[index])

            const payload = {
                magazineInfo: item,  //value
                quantity:  this.selectedRequestProduct[index],
                Device: this.DeviceSelectedName,

            };
            console.log("Recharge payload", payload);
            if (typeof payload.amount !== 'undefined') {
                console.log("Quantity is OK!")
            }
            else if ((parseInt(payload.quantity)  > parseInt(item.max_capacity))) {
                this.showNotification("ভুল ইনপুট", "রিফিল পরিমাণ ডিভাইসের ধারণক্ষমতার চেয়ে বেশি।", "danger");
            }
            else {

                var disdata = {};
                this.loadingIndex = index;
                getAPI.post('/mismatch/', payload, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`
                    }
                })
                .then(response => {
                    disdata = response['data'];
                    console.log(disdata);
                    this.loadingIndex = null;
                    const currentTime = moment().format('D/M/YYYY h:mm A');
                    const reportText = `⚠️ *Mismatch Update*

*${this.DeviceSelectedName}*
Mag: ${item.magazine_number}

*${item.product_type}*
_(${item.pack_system})_

*Status:*
Server: ${item.count}
Device: ${payload.quantity}

🕒 _${currentTime}_`;


                    this.showNotification("সফল হয়েছে", "আপডেট সম্পন্ন হয়েছে। নিচের তথ্যটি কপি করুন:", "success", true, reportText);
                })
                .catch(error => {
                    console.error("API Error:", error);
                    this.loadingIndex = null;
                    this.showNotification("ত্রুটি", "আপডেট ব্যর্থ হয়েছে। আবার চেষ্টা করুন।", "danger", false);
                });

            }
        },
        goToRefillPage() {
            this.$router.push('/refillProduct'); 
        }

    }
}
</script>

<style scoped>
/* Header Banner Styles */
.header-banner {
    border: 1px solid #e0e4e8;
    border-left: 5px solid #007bff; /* Primary blue accent */
    transition: box-shadow 0.3s ease;
}

.header-banner:hover {
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.1)!important; 
}

.tracking-wide {
    letter-spacing: 0.05em;
}

/* Enhanced Back Button Styles */
.btn-back {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border-color: #ced4da;
}

.btn-back:hover {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
    transform: translateX(-4px); /* Slightly stronger nudge */
    box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3) !important;
}
/* Back Button Styles */
.btn-outline-secondary {
    transition: all 0.3s ease;
}

.btn-outline-secondary:hover {
    background-color: #6c757d;
    color: white;
    transform: translateX(-3px);
}

/* Mobile Card Styles */
.custom-mobile-card {
    border-radius: 12px;
    border: 1px solid #e0e4e8 !important;
}

.stats-box {
    border-color: #e0e4e8 !important;
}

@media (max-width: 575.98px) {
    h2 {
        font-size: 1.5rem;
    }
    h3 {
        font-size: 1.2rem !important;
    }
}
</style>